import { all, fork } from "redux-saga/effects";

import loginRootSaga from "./loginSagas";

export default function* rootSaga() {
  try {
    yield all([fork(loginRootSaga)]);
  } catch (error) {
    console.error("rootSaga failed", error);
  }
}
